export const ITEM_TYPES = {
  WorkAssignment: 'WORK_ASSIGNMENT',
  WorkAssignmentListAttachment: 'WORK_ASSIGNMENT_LIST_ATTACHMENT',
  User: 'USER',
  Team: 'TEAM',
  Position: 'POSITION',
  Sitrep: 'SITREP',
  InternalLayerVersion: 'INTERNAL_LAYER_VERSION',
  ResourceRequest: 'RESOURCE_REQUEST',
} as const;

export type ItemType = (typeof ITEM_TYPES)[keyof typeof ITEM_TYPES];
